// SelectedFilters.jsx
import React from "react";
function SelectedFilters({
  items,
  onRemove,
  onClearAll
}) {
  if (!items.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "ff-selected-row"
  }, items.map(item => /*#__PURE__*/React.createElement("button", {
    key: item.id,
    type: "button",
    className: "ff-selected-pill",
    onClick: () => onRemove(item)
  }, item.label, /*#__PURE__*/React.createElement("span", {
    className: "ff-selected-pill__x"
  }, "\xD7"))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "ff-selected-clear",
    onClick: onClearAll
  }, "Clear All"));
}
export { SelectedFilters };